/* eslint-disable prettier/prettier */
/* eslint-disable react/prop-types */
import { useMemo } from "react";
import {
  MaterialReactTable,
  useMaterialReactTable,
  MRT_ActionMenuItem,
} from "material-react-table";
import { MRT_Localization_ES } from "material-react-table/locales/es";

import MDTypography from "components/MDTypography";
import Icon from "@mui/material/Icon";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
//nested data is ok, see accessorKeys in ColumnDef below
import { mkConfig, generateCsv, download } from "export-to-csv";

const Example = ({ columns, data, showModal }) => {
  //should be memoized or stable
  const csvConfig = mkConfig({
    fieldSeparator: ",",
    decimalSeparator: ".",
    useKeysAsHeaders: true,
    filename: "Solicitudes",
  });
  const handleExportRows = (rows) => {
    const rowData = rows.map((row) => row.original);
    const csv = generateCsv(csvConfig)(rowData);
    download(csvConfig)(csv);
  };

  const handleExportData = () => {
    const csv = generateCsv(csvConfig)(data);
    download(csvConfig)(csv);
  };

  return (
    <MaterialReactTable
      columns={columns}
      data={data}
      localization={MRT_Localization_ES}
      autoResetPageIndex={false}
      initialState={{
        density: "compact",
      }}
      muiTableHeadProps={{
        sx: { display: "table-header-group" },
      }}
      paginationDisplayMode="pages"
      muiPaginationProps={{
        sx: {
          // Estilo general del componente de paginación
          "& .MuiPaginationItem-root": {
            color: "#FFFFFF", // Color de todos los números de página
          },
          "& .Mui-selected": {
            fontWeight: "bold",
            color: "#F58020", // Color del texto seleccionado
          },
        },
      }}
      muiTableBodyCellProps={({ row, cell }) => {
        return {
          sx: {
            color: "#FFFFFF",
            opacity: "0.7",
            fontSize: 12,
          },
        };
      }}
      muiTableHeadCellProps={{
        sx: { color: "#FFFFFF", fontSize: 12 },
      }}
      icons={{
        SearchIcon: () => <Icon color="primary">search</Icon>,
        SearchOffIcon: () => <Icon color="primary">search_off</Icon>,
        CloseIcon: () => <Icon color="primary">close</Icon>,
        FullscreenIcon: () => <Icon color="primary">fullscreen</Icon>,
        FullscreenExitIcon: () => <Icon color="primary">fullscreen_exit</Icon>,
        FilterAltIcon: () => <Icon color="primary">search</Icon>,
        FilterListIcon: () => <Icon color="primary">filter_list</Icon>,
        FilterListOffIcon: () => <Icon color="primary">filter_list_off</Icon>,
        DensitySmallIcon: () => <Icon color="primary">density_small</Icon>,
        DensityMediumIcon: () => <Icon color="primary">density_medium</Icon>,
        DensityLargeIcon: () => <Icon color="primary">density_large</Icon>,
        FirstPageIcon: () => <Icon color="primary">first_page</Icon>,
        LastPageIcon: () => <Icon color="primary">last_page</Icon>,
        ChevronLeftIcon: () => <Icon color="primary">navigate_before</Icon>,
        ChevronRightIcon: () => <Icon color="primary">navigate_next</Icon>,
        MoreVertIcon: () => <Icon color="primary">more_vert</Icon>,
        MoreHorizIcon: () => <Icon color="primary">more_horiz</Icon>,
        SortIcon: () => <Icon color="primary">sort</Icon>,
        ClearAllIcon: () => <Icon color="primary">clear_all</Icon>,
        VisibilityOffIcon: () => <Icon color="primary">visibility_off</Icon>,
        ViewColumnIcon: () => <Icon color="primary">view_column</Icon>,
        SyncAltIcon: () => <Icon color="primary">import_export</Icon>,

        ArrowDownwardIcon: (props) => {
          var icon = <Icon color="primary">arrow_downward</Icon>;
          props.className ===
          "MuiTableSortLabel-icon MuiTableSortLabel-iconDirectionAsc css-1hi7cb7-MuiTableSortLabel-icon"
            ? (icon = <Icon color="primary">arrow_upward</Icon>)
            : (icon = <Icon color="primary">arrow_downward</Icon>);

          return icon;
        },
      }}
      enableRowActions={false}
      renderRowActionMenuItems={({ row, table }) => [
        <MRT_ActionMenuItem
          icon={<Icon color="success">preview</Icon>}
          key="ver"
          label="Ver solicitud"
          onClick={() => {}}
          table={table}
        />,
        <MRT_ActionMenuItem //or just use a normal MUI MenuItem component
          icon={<Icon color="error">delete</Icon>}
          key="edit"
          label="Eliminar solicitud"
          onClick={() => {}}
          table={table}
        />,
        <MRT_ActionMenuItem
          icon={<Icon color="warning">picture_as_pdf</Icon>}
          key="delete"
          label="Descargar solicitud"
          onClick={() => {}}
          table={table}
        />,
        <MRT_ActionMenuItem
          icon={<Icon color="warning">circle_notifications</Icon>}
          key="notifi"
          label="Notificaciones"
          onClick={() => {}}
          table={table}
        />,
      ]}
    />
  );
};

export default Example;
